export default __webpack_public_path__ + "static/news13-0ba5d0327f19fe05482a8cabca935b92.jpeg";